import React, {useEffect, useReducer} from 'react';
import {Button, Col, Form, InputGroup, Modal, OverlayTrigger, Row, Tooltip} from '@themesberg/react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCalendarAlt, faPen, faPercent, faPowerOff, faTag, faTrashCan} from '@fortawesome/free-solid-svg-icons';
import {FormattedMessage} from 'react-intl';
import Utils from '../services/Utils';
import {useHistory} from 'react-router-dom';
import API from '../services/API';
import Error from '../services/Error';
import Datetime from 'react-datetime';
import moment from 'moment-timezone';
import 'moment/locale/fr';
import 'moment/locale/es';
import PageHeader from '../components/PageHeader';
import CrudTable from '../components/CrudTable';
import {usePlan} from '../services/PlanContext';


export default (props) => {

  const formReducer = (state, event) => {
    if (event.value !== undefined) {
      return {
        ...state,
        [event.name]: event.value
      }
    } else {
      return event;
    }
  }

  const {intl} = props;
  const {plan, resourceLimit, openSubscription} = usePlan();
  const history = useHistory();
  const focus = ['focus'];
  const [showModal, setShowModal] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [editModalMode, setEditModalMode] = React.useState(false);
  const [currentDiscountCodeId, setCurrentDiscountCodeId] = React.useState(false);
  const [currentDiscountCodeName, setCurrentDiscountCodeName] = React.useState('');
  const [vehicles, setVehicles] = React.useState([]);
  const [discountCodes, setDiscountCodes] = React.useState([]);
  // Limite calculée sur la liste locale (à jour après création/suppression), pas sur le compteur du plan.
  const locked = plan === 'FREE' && resourceLimit != null && discountCodes.length >= resourceLimit;
  const [formData, setFormData] = useReducer(formReducer, {});
  const [currency, setCurrency] = React.useState({code: 'EUR', symbol: '€'});
  const [formatter, setFormatter] = React.useState(new Intl.NumberFormat(navigator.language, {style: 'currency', currency: 'EUR'}));
  const DATE_FORMAT = 'YYYY/MM/DD';
  const FR_DATE_FORMAT = 'DD/MM/YYYY';

  const getLocaleDateFormat = () => {
    return Utils.getLanguage().toUpperCase() === 'FR' ? FR_DATE_FORMAT : DATE_FORMAT;
  }

  const refreshDiscountCodes = () => {
    API.getDiscountCodes(history).then(response => {
      if (response && response.data.success === true) {
        setDiscountCodes(response.data.data.discountCodes);
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  useEffect(() => {
    if (!Utils.isAccessToken(history)) {
      return;
    }
    refreshDiscountCodes();
    API.getCurrency(history).then(response => {
      if (response && response.data.success === true) {
        setFormatter(new Intl.NumberFormat(navigator.language, {
          style: 'currency',
          currency: response.data.data.code,
        }));
        setCurrency(response.data.data);
      }
    });
  }, []);

  const getVehicles = () => {
    API.getVehicles(history).then(response => {
      if (response && response.data.success === true) {
        const vehicles = response.data.data.vehicles.sort(function (a, b) {
          return a.position - b.position
        });
        setVehicles(vehicles);
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  const handleChange = event => {
    setFormData({
      name: event.target.id,
      value: event.target.value
    });
  }

  const handleChangeCode = event => {
    setFormData({
      name: event.target.id,
      value: event.target.value.replace(/\s/g, '')
    });
  }

  const handleChangeStartDate = value => {
    setFormData({
      name: 'startDate',
      value: moment(value).format(DATE_FORMAT)
    });
  }

  const handleChangeEndDate = value => {
    setFormData({
      name: 'endDate',
      value: moment(value).format(DATE_FORMAT)
    });
  }

  const handleAddOrEdit = (e) => {
    e.preventDefault();

    if (vehicles.length === 0) {
      getVehicles();
    }

    if (editModalMode) {

      if (!formData.vehicleId) {
        formData.vehicleId = -1; // All vehicles
      }

      API.putDiscountCodes(history, formData, currentDiscountCodeId).then(response => {
        if (response && response.data.success === true) {
          Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'SAVED_CHANGES'}));
          setShowModal(false);
          refreshDiscountCodes();
        } else if (response && response.data.success === false && response.data.data === Error.discountCodeInvalidDates()) {
          Utils.notifyWarning(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'DISCOUNT_CODE_INVALID_DATES'}));
        } else if (response && response.data.success === false && response.data.data === Error.discountCodeWithoutDiscount()) {
          Utils.notifyWarning(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'DISCOUNT_CODE_WITHOUT_DISCOUNT'}));
        } else {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
        }
      });
    } else {

      if (!formData.vehicleId) {
        formData.vehicleId = -1; // All vehicles
      }

      API.postDiscountCodes(history, formData).then(response => {
        if (response && response.data.success === true) {
          Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'DISCOUNT_CODE_ADDED'}));
          setShowModal(false);
          refreshDiscountCodes();
        } else if (response && response.data.success === false && response.data.data === Error.discountCodeAlreadyExists()) {
          Utils.notifyWarning(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'DISCOUNT_CODE_ALREADY_EXISTS'}));
        } else if (response && response.data.success === false && response.data.data === Error.discountCodeInvalidDates()) {
          Utils.notifyWarning(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'DISCOUNT_CODE_INVALID_DATES'}));
        } else if (response && response.data.success === false && response.data.data === Error.discountCodeWithoutDiscount()) {
          Utils.notifyWarning(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'DISCOUNT_CODE_WITHOUT_DISCOUNT'}));
        } else if (response && response.data && response.data.data === Error.planLimitReached()) {
          setShowModal(false);
          openSubscription('RESOURCE_LIMIT');
        } else {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
        }
      });
    }
  }

  const handleNewDiscountCodeButton = () => {
    if (vehicles.length === 0) {
      getVehicles();
    }

    setFormData({});
    setEditModalMode(false);
    setShowModal(true);
  }

  const handleEditDiscountCodeButton = (props) => {
    let data = Object.assign({}, props);

    if (vehicles.length === 0) {
      getVehicles();
    }

    setFormData(data);
    setCurrentDiscountCodeId(data.id);
    setEditModalMode(true);
    setShowModal(true);
  }

  const handleEnableOrDisableButton = (props) => {
    if (props.active) {
      API.getDisableDiscountCode(history, props.id).then(response => {
        if (response && response.data.success === true) {
          Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'DISCOUNT_CODE_DISABLED'}));
          refreshDiscountCodes();
        } else {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
        }
      });
    } else {
      API.getEnableDiscountCode(history, props.id).then(response => {
        if (response && response.data.success === true) {
          // Gratuit : activer un 2ᵉ code promo bascule l'actif au lieu de bloquer -> toast dédié.
          const switched = response.data.data === Error.resourceSwitched();
          Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: switched ? 'DISCOUNT_CODE_SWITCHED' : 'DISCOUNT_CODE_ENABLED'}));
          refreshDiscountCodes();
        } else if (response && response.data.success === false && response.data.data === Error.discountCodeCannotBeEnabledWithoutVehicule()) {
          Utils.notifyWarning(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'YOU_MUST_ASSIGN_VEHICLE_BEFORE'}));
        } else {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
        }
      });
    }
  }

  const handleDeleteDiscountCodeButton = (props) => {
    setCurrentDiscountCodeId(props.id);
    setCurrentDiscountCodeName(props.code);
    setShowDeleteModal(true);
  }

  const deleteDiscountCode = () => {
    API.deleteDiscountCodes(history, currentDiscountCodeId).then(response => {
      if (response && response.data.success === true) {
        Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'DISCOUNT_CODE_DELETED'}));
        setShowDeleteModal(false);
        refreshDiscountCodes()
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  return (
    <div className="ccv2-crud">
      <PageHeader title="DISCOUNT_CODES" description="DISCOUNT_CODES_DESC"/>

      <CrudTable
        items={discountCodes}
        intl={intl}
        columns={[
          {key: 'code', header: 'CODE', priority: 1},
          {key: 'fixedDiscount', header: 'FIXED_REDUCTION_AMOUNT', headerMultiline: true, numeric: true, priority: 2, render: (d) => formatter.format(d.fixedDiscount)},
          {key: 'percentageDiscount', header: 'DISCOUNT_PERCENTAGE', headerMultiline: true, numeric: true, priority: 2, render: (d) => <>{d.percentageDiscount}{d.percentageDiscount ? ' %' : ''}</>},
          {key: 'usage', header: 'USAGE', priority: 2, render: (d) => (d.used ? d.used : 0) + ' / ' + (d.maxUsage ? (d.maxUsage === 0 ? '~' : d.maxUsage) : '~')},
          {key: 'minAmount', header: 'MINIMUM_AMOUNT', headerMultiline: true, numeric: true, priority: 3, hideBelow: 'lg', render: (d) => (d.minAmount ? formatter.format(d.minAmount) : '')},
          {key: 'startDate', header: 'START_DATE', headerMultiline: true, priority: 3, hideBelow: 'lg', render: (d) => (d.startDate ? moment(d.startDate).format(getLocaleDateFormat()) : '')},
          {key: 'endDate', header: 'END_DATE', headerMultiline: true, priority: 3, hideBelow: 'lg', render: (d) => (d.endDate ? moment(d.endDate).format(getLocaleDateFormat()) : '')},
          {key: 'vehicle', header: 'VEHICLE', priority: 3, hideBelow: 'lg', render: (d) => (d.vehicleId === -1 ? intl.formatMessage({id: 'ALL_VEHICLES'}) : d.vehicleName)},
          {key: 'active', header: 'ACTIVE_TAB', type: 'status', priority: 2},
        ]}
        actions={[
          {key: 'edit', icon: faPen, label: 'EDIT', onClick: handleEditDiscountCodeButton},
          {key: 'toggle', icon: faPowerOff, label: (d) => (d.active ? 'DISABLE' : 'ENABLE'), intent: 'warn', onClick: handleEnableOrDisableButton},
          {key: 'delete', icon: faTrashCan, label: 'DELETE', intent: 'danger', onClick: handleDeleteDiscountCodeButton},
        ]}
        toolbar={{onNew: handleNewDiscountCodeButton, newLabel: 'NEW_DISCOUNT_CODE', locked}}
        empty={{icon: faTag, title: 'EMPTY_DISCOUNTS_TITLE', description: 'EMPTY_DISCOUNTS_DESC'}}
      />

      <Modal as={Modal.Dialog} centered show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title className="h6">{editModalMode ? <FormattedMessage id="EDIT_DISCOUNT_CODE"/> : <FormattedMessage id="NEW_DISCOUNT_CODE"/>}</Modal.Title>
          <Button variant="close" aria-label="Close" onClick={() => setShowModal(false)}/>
        </Modal.Header>
        <Modal.Body>
          <Form id="add-discount-form" onSubmit={handleAddOrEdit}>
            <Row>
              <Form.Group>
                <Form.Label><FormattedMessage id="CODE"/></Form.Label>
                <Form.Control required type="text" id="code" maxLength="32" disabled={editModalMode}
                              onChange={handleChangeCode} value={formData.code}/>
              </Form.Group>
            </Row>
            <br/>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="FIXED_REDUCTION_AMOUNT" values={{newLine: ' '}}/></Form.Label>
                  <InputGroup>
                    <InputGroup.Text style={editModalMode ? {background: '#f5f8fb'} : {}}>
                      <FontAwesomeIcon icon={Utils.getCurrencyIcon(currency.code)}/>
                    </InputGroup.Text>
                    <Form.Control type="number" id="fixedDiscount" step="any" min="0" disabled={editModalMode}
                                  onChange={handleChange} value={formData.fixedDiscount}/>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="DISCOUNT_PERCENTAGE" values={{newLine: ' '}}/></Form.Label>
                  <InputGroup>
                    <InputGroup.Text style={editModalMode ? {background: '#f5f8fb'} : {}}>
                      <FontAwesomeIcon icon={faPercent}/>
                    </InputGroup.Text>
                    <Form.Control type="number" id="percentageDiscount" step="any" min="0" disabled={editModalMode}
                                  onChange={handleChange} value={formData.percentageDiscount}/>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <br/>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="START_DATE" values={{newLine: ' '}}/></Form.Label>
                  <Datetime
                    locale={Utils.getLanguage()}
                    timeFormat={false}
                    closeOnSelect={true}
                    onChange={handleChangeStartDate}
                    renderInput={(props, openCalendar) => (
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faCalendarAlt}/>
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          value={formData.startDate ? moment(formData.startDate).format(getLocaleDateFormat()) : ''}
                          onFocus={openCalendar}/>
                      </InputGroup>
                    )}/>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="END_DATE" values={{newLine: ' '}}/></Form.Label>
                  <Datetime
                    locale={Utils.getLanguage()}
                    timeFormat={false}
                    closeOnSelect={true}
                    onChange={handleChangeEndDate}
                    renderInput={(props, openCalendar) => (
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faCalendarAlt}/>
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          value={formData.endDate ? moment(formData.endDate).format(getLocaleDateFormat()) : ''}
                          onFocus={openCalendar}/>
                      </InputGroup>
                    )}/>
                </Form.Group>
              </Col>
            </Row>
            <br/>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="MINIMUM_AMOUNT" values={{newLine: ' '}}/></Form.Label>
                  <OverlayTrigger trigger={focus}
                                  overlay={
                                    <Tooltip><FormattedMessage id="TOOLTIP_MINIMUM_AMOUNT"/></Tooltip>
                                  }>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={Utils.getCurrencyIcon(currency.code)}/>
                      </InputGroup.Text>
                      <Form.Control type="number" id="minAmount" step="any" min="0"
                                    onChange={handleChange} value={formData.minAmount}/>
                    </InputGroup>
                  </OverlayTrigger>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="MAXIMUM_USAGE"/></Form.Label>
                  <OverlayTrigger trigger={focus}
                                  overlay={
                                    <Tooltip><FormattedMessage id="TOOLTIP_MAXIMUM_USAGE"/></Tooltip>
                                  }>
                    <Form.Control type="number" id="maxUsage" step="any" min="0"
                                  onChange={handleChange} value={formData.maxUsage}/>
                  </OverlayTrigger>
                </Form.Group>
              </Col>
            </Row>
            <br/>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="VEHICLE"/></Form.Label>
                  <Form.Select id="vehicleId" onChange={handleChange} value={formData.vehicleId}>
                    <option key={`vehicle-all`} value={-1}>{intl.formatMessage({id: 'ALL_VEHICLES'})}</option>
                    {vehicles.map(v => <option key={`vehicle-${v.id}`} value={v.id}>{v.name}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" type="submit" form="add-discount-form">
            {editModalMode ? <FormattedMessage id="RECORD"/> : <FormattedMessage id="ADD"/>}
          </Button>
          <Button variant="link" className="text-gray ms-auto" onClick={() => setShowModal(false)}>
            <FormattedMessage id="CLOSE"/>
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal as={Modal.Dialog} centered show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header>
          <Modal.Title className="h6"><FormattedMessage id="DELETE_DISCOUNT_CODE" values={{code: currentDiscountCodeName}}/></Modal.Title>
          <Button variant="close" aria-label="Close" onClick={() => setShowDeleteModal(false)}/>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="danger" onClick={deleteDiscountCode}>
            <FormattedMessage id="DELETE"/>
          </Button>
          <Button variant="link" className="text-gray ms-auto" onClick={() => setShowDeleteModal(false)}>
            <FormattedMessage id="CLOSE"/>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
    ;
};
